export default __webpack_public_path__ + "static/media/Link Object to Event.449b8f9b.mp4";